import {
  Box,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { AccountCircleOutlined } from '@mui/icons-material';
import AccountOverviewSummaryCard from './AccountOverviewSummaryCard';
import { formatCurrency } from './accountOverview.utils';

export default function AccountOverviewStatusGrid({
  summary,
  statusMeta,
  statusDateLabel,
  statusDateValue,
  subscriptionCustomPricing,
  cancelInfo,
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
        gap: 2.5,
      }}
    >
      <AccountOverviewSummaryCard
        title="Conta"
        icon={<AccountCircleOutlined sx={{ fontSize: 22 }} />}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: '#0f172a', letterSpacing: '-0.01em', lineHeight: 1.2 }}
        >
          {summary?.user?.name || 'Usuário'}
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
          {summary?.user?.email || 'E-mail não informado'}
        </Typography>
      </AccountOverviewSummaryCard>

      <AccountOverviewSummaryCard
        title="Status da assinatura"
        icon={
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              bgcolor: statusMeta.dot,
              boxShadow: `0 0 0 4px ${statusMeta.bg}`,
              animation: 'pulse-status 2s ease-in-out infinite',
              '@keyframes pulse-status': {
                '0%, 100%': { transform: 'scale(1)', opacity: 1 },
                '50%': { transform: 'scale(1.15)', opacity: 0.85 },
              },
            }}
          />
        }
      >
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: '#0f172a', letterSpacing: '-0.01em' }}
          >
            {statusMeta.label}
          </Typography>
        </Stack>
        <Divider sx={{ my: 2, borderColor: 'rgba(15, 23, 42, 0.06)' }} />
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
          <Typography
            variant="caption"
            sx={{
              color: '#64748b',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              fontWeight: 600,
              fontSize: '0.7rem',
            }}
          >
            {statusDateLabel}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600, color: '#0f172a' }}>
            {statusDateValue}
          </Typography>
        </Stack>
        {subscriptionCustomPricing && (
          <Box
            sx={{
              mt: 2,
              p: 1.5,
              borderRadius: '12px',
              background: 'rgba(8, 145, 178, 0.08)',
              border: '1px solid rgba(8, 145, 178, 0.18)',
            }}
          >
            <Stack spacing={0.75}>
              <Stack direction="row" justifyContent="space-between" gap={2}>
                <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>
                  Mensalidade atual
                </Typography>
                <Typography variant="body2" sx={{ color: '#0f172a', fontWeight: 800 }}>
                  {formatCurrency(subscriptionCustomPricing.totalAmount, 'brl')}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" gap={2}>
                <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>
                  Desconto progressivo
                </Typography>
                <Typography variant="body2" sx={{ color: '#047857', fontWeight: 800 }}>
                  {subscriptionCustomPricing.discountPercent || 0}% em {subscriptionCustomPricing.productCount || 0} produtos
                </Typography>
              </Stack>
            </Stack>
          </Box>
        )}
        {cancelInfo && (
          <Box
            sx={{
              mt: 2,
              p: 1.5,
              borderRadius: '12px',
              background: 'rgba(245, 158, 11, 0.10)',
              border: '1px solid rgba(245, 158, 11, 0.24)',
            }}
          >
            <Typography variant="body2" sx={{ color: '#92400e', fontWeight: 500 }}>
              {cancelInfo}
            </Typography>
          </Box>
        )}
      </AccountOverviewSummaryCard>
    </Box>
  );
}
